export default __webpack_public_path__ + "static/beneficios-3-2da74e98839cd8d93ad3186d2c15488a.jpg";